(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["page52-age-gate"] && !Shopify.designMode) return;
  try {
    (function () {
  function init() {
    const screen = document.getElementById('p52-global-age-screen');
    const dialog = document.getElementById('p52-global-age-dialog');
    const actions = document.getElementById('p52-global-age-actions');
    const yes = document.getElementById('p52-global-age-yes');
    const no = document.getElementById('p52-global-age-no');
    if (!screen || !dialog || !actions || !yes || !no || screen.dataset.ready) return;
    if (document.getElementById('p52-age-screen')) { screen.remove(); return; }
    screen.dataset.ready = '1';
    const visit = window.page52AgeVisit;
    const state = visit ? visit.read() : '';
    function save(value) { if (visit) visit.save(value); }
    function pass() {
      document.documentElement.classList.add('p52-age-confirmed');
      if (dialog.open) dialog.close();
      screen.hidden = true;
      const main = document.querySelector('main');
      const target = main && (main.querySelector('a, button, input') || main);
      if (target) {
        const previous = target.getAttribute('tabindex');
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (previous === null) target.removeAttribute('tabindex');
        else target.setAttribute('tabindex', previous);
      }
    }
    function deny() {
      save('denied');
      document.documentElement.classList.remove('p52-age-confirmed');
      actions.hidden = true;
      document.getElementById('p52-global-age-title').textContent = 'Please come back when you are of age.';
      document.getElementById('p52-global-age-copy').textContent = 'Access is limited to visitors who are 21 or older and of legal drinking age in their location.';
      dialog.querySelector('.age-exit').focus();
    }
    if (state === 'passed') { pass(); return; }
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); });
    if (dialog.open) dialog.close();
    dialog.showModal();
    if (state === 'denied') { deny(); return; }
    yes.addEventListener('click', function () { save('passed'); pass(); });
    no.addEventListener('click', function () {
      deny();
      window.location.assign('https://www.responsibility.org/');
    });
    yes.focus();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
  } catch(e) { console.error(e); }
})();

})();
